import React from "react";
import SaveButton from "../../../../common/nav/SaveButton";
import baseStyles from "../EditBase.module.scss";
import styles from "./EditWork.module.scss";
import EditWorkItem from "./EditWorkItem";
import EditWorkModal from "./EditWorkModal";
import { SonicWorkInputData } from "./SonicWorkInputData";

type Props = {
  works?: Array<SonicWorkInputData>;
  isEditWork: boolean;
  editWorkNumber: number;
  addWork: () => void;
  editWork: (i: number, work: SonicWorkInputData) => void;
  setIsEditWork: (value: boolean) => void;
  setEditWorkNumber: (i: number) => void;
  deleteWork: (i: number) => void;
};
const EditWork: React.FC<Props> = ({
  works,
  isEditWork,
  editWorkNumber,
  addWork,
  editWork,
  setIsEditWork,
  setEditWorkNumber,
  deleteWork,
}) => {
  return (
    <>
      <div className={baseStyles["p-edit__wrapper"]}>
        <div className={baseStyles["p-edit__inner"]}>
          <div className={baseStyles["p-edit__title"]}>
            作品
            <div className={baseStyles["p-edit__title-desc"]}>
              画像、イラスト、動画、音源などあなたの作品を登録すると依頼のチャンスが増えます。
            </div>
          </div>
          <div className={styles["edit-work"]}>
            {works?.map((work, i) => (
              <div key={i} className={styles["edit-workItem-wrapper"]}>
                <EditWorkItem
                  index={i}
                  title={work.title}
                  img_src={work.image}
                  link={work.link}
                  setIsEditWork={setIsEditWork}
                  setEditWorkNumber={setEditWorkNumber}
                  deleteWork={deleteWork}
                />
              </div>
            ))}
          </div>
          <div className={styles["add-work"]}>
            <SaveButton title="作品を追加する" onClick={addWork} />
          </div>
        </div>
      </div>

      {isEditWork ? (
        <EditWorkModal
          index={editWorkNumber}
          image={works?.[editWorkNumber]?.image}
          title={works?.[editWorkNumber]?.title}
          link={works?.[editWorkNumber]?.link}
          description={works?.[editWorkNumber]?.description}
          editWork={editWork}
          closeHandler={() => setIsEditWork(false)}
        />
      ) : null}
    </>
  );
};

export default EditWork;
